module.exports = __webpack_public_path__ + "static/img/ddhzyk-img5.17604566.jpg";